var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiomarkerRedAlert({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0019 17.4608L21.7271 21.4014H2.27528L0 17.4608L9.72632 0.615234H14.2761L24.0019 17.4608Z",
    fill: "#E74C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7933 6.21094H11.1944L10.7969 6.65256L11.5963 14.2475H12.3913L13.1908 6.65256L12.7933 6.21094Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9948 17.0052C12.4363 17.0052 12.7942 16.6473 12.7942 16.2057C12.7942 15.7642 12.4363 15.4062 11.9948 15.4062C11.5532 15.4062 11.1953 15.7642 11.1953 16.2057C11.1953 16.6473 11.5532 17.0052 11.9948 17.0052Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiomarkerRedAlert);
export default __webpack_public_path__ + "static/media/biomarker-red-alert.79a9ca69ad09068347096b2396b06e90.svg";
export { ForwardRef as ReactComponent };